import React, { useState } from 'react'
import { pascalCase } from 'change-case'
import { connect } from 'react-redux'
import { 
  Field, 
  getFormValues, 
  SubmissionError 
} from 'redux-form'
import { 
  TextArea, 
  Button, 
  Confirm, 
  Dropdown, 
  Input 
} from  'semantic-ui-react'

import { Cont } from './styled'
import { StdCard } from 'components'
import { rfqAction } from 'ducks/rfq'
import FieldInput, { InputType as type } from 'components/SemanticForm'

const Approve = (props) => {
  const { 
    rfqDetail={}, 
    handleSubmit, 
    rfqAction, 
    valueForm,
    history 
  } = props
  const approverAction = rfqDetail.actions||[]
  const sn = rfqDetail.sn || ''

  const [showApprovalChat, setShowApprovalChat] = useState(false)
  const [submitActionName, setSubmitActionName] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)

  function submitValidate(action){
    setSubmitActionName(action)
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100) // simulate server latency
    .then(() => {
      if(action.toLowerCase() === 'reject'||action.toLowerCase() === 'revise') {
        if((valueForm.comment&&valueForm.comment.trim().length === 0)||!valueForm.comment) {
          throw new SubmissionError({ comment: 'Required!'})
        }
      }
      setShowConfirm(true)
    })
  }

  function submitAction() {
    setShowConfirm(false)
    rfqAction({
      docId: valueForm.id,
      sn: sn,
      action: submitActionName,
      comment: valueForm.comment,
      title: valueForm.title,
      commentAttachments: valueForm.commentAttachments
    }, history)
  }

  return (
    approverAction.length === 0 ? null :
    <StdCard title='Action for Approval' highlight style={{ marginTop: '1rem' }} enableCollapse={false}>
      <Cont>
        <div style={{ display:'flex', flexDirection: 'column' }}>
          <Field 
            name='comment' 
            label='Your Comment' 
            type={type.textArea}
            containerStyle={{ marginRight: '0px' }}
            component={FieldInput} /> 
          <Field
            name='commentAttachments'
            label='Attachments'
            type={type.file}
            component={FieldInput}
            containerStyle={{ marginRight: 0 }}
          />
          <div style={{ marginTop: '1rem' }}>
            {
              approverAction.map((item) => 
                <Button 
                  key={item}
                  type='button' 
                  color={`${item.toLowerCase()==='reject'?'red':item.toLowerCase()==='revise'?'orange':'green'}`}
                  onClick={
                    handleSubmit(()=>submitValidate(item))
                  }
                >
                  {pascalCase(item)}
                </Button>
              )
            }
          </div>
        </div>
        <Confirm
          size='mini'
          open={showConfirm}
          onCancel={() => setShowConfirm(false)}
          onConfirm={() => submitAction()}
        />  
      </Cont>
    </StdCard>
  )

}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formRFQ')(state),
  })
}

const mapDispatchToProps = {
  rfqAction
}

export default connect(mapStateToProps, mapDispatchToProps)(Approve)
